import { Link } from 'react-router-dom';
import { siteInfo } from '@/lib/content';

const columns = [
  {
    title: '内容导览',
    links: [
      { label: '剧情介绍', to: '/story' },
      { label: '演员详情', to: '/cast' },
      { label: '影视资讯', to: '/news' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '站点介绍', to: '/about' },
      { label: '使用说明', to: '/about' },
      { label: '版权声明', to: '/about' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-primary-500/20 bg-secondary-800">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-500/50 text-primary-400">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {siteInfo.brand}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              专注剧集《{siteInfo.brand}》的剧情梳理、演员档案与幕后资讯。本站为影视内容展示站点，所有人物、情节与报道均为虚构示例，仅用于内容演示。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              本站不提供在线播放、下载、登录或收藏功能。
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h2 className="text-xs font-label tracking-[0.28em] text-primary-400">
                {column.title}
              </h2>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-foreground-950"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-secondary-600/40 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {siteInfo.year} {siteInfo.brand} 影视资料站 · 内容均为虚构演示
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
            <span className="flex items-center gap-2 whitespace-nowrap">
              <i className="ri-mail-line text-sm"></i>
              {siteInfo.email}
            </span>
            <span className="flex items-center gap-2 whitespace-nowrap">
              <i className="ri-time-line text-sm"></i>
              每日更新剧情与资讯
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}